import React from 'react';
import Box from '@material-ui/core/Box';
import Progress from 'bit/mobiauto.web-ui-components.components.progress/Progress';
import ChatHeader from 'pages/chats/components/Header';
import proposalIsFinished from 'pages/chats/helpers/proposalIsFinished';
import ProposalErrorPage from 'pages/chats/components/ProposalErrorPage';
import Page from 'components/Page';
import Chat from '../components/Chat';
import SideBar from './components/SideBar';
import SubHeader from '../components/SubHeader';
import { Container, Content } from './styles';

const ChatCallCenterComponent = ({
  currentProposal,
  currentProposalStatus,
  handleOnClickBack,
  handleOnClickClose,
  onModal,
  proposalError,
  onFetchCurrentDealerProducts,
  vision,
}) => {
  if (onFetchCurrentDealerProducts) {
    return (
      <Box
        component="div"
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Progress />
      </Box>
    );
  }

  return (
    <Page withoutPadding>
      <ChatHeader
        error={proposalError}
        currentProposal={currentProposal}
        handleOnClickBack={handleOnClickBack}
        onModal={onModal}
        handleOnClickClose={handleOnClickClose}
      />
      {proposalError ? (
        <ProposalErrorPage />
      ) : (
        <Container isFinished={proposalIsFinished(currentProposal)}>
          <SubHeader
            vision={vision}
            currentProposalStatus={currentProposalStatus}
          />
          <Content>
            <Chat />
            <SideBar />
          </Content>
        </Container>
      )}
    </Page>
  );
};

export default ChatCallCenterComponent;
